module.exports = __webpack_public_path__ + "static/img/hb_12-min.77147eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_12-min.png
// module id = jo79
// module chunks = 1